import { daysInUTCMonth, differenceInUTCDays, parseDateUTC, sameUTCDate, toDateKeyUTC, } from './dates.js';
export function findOverride(transaction, date) {
    const dateKey = toDateKeyUTC(date);
    return transaction.overrides?.find((override) => toDateKeyUTC(override.date) === dateKey);
}
export function occursOnDate(transaction, dateInput, options = {}) {
    if (transaction.active === false || transaction.date === undefined || transaction.date === null) {
        return false;
    }
    const date = parseDateUTC(dateInput);
    const start = parseDateUTC(transaction.date);
    if (date < start) {
        return false;
    }
    if (transaction.limitDate !== undefined && transaction.limitDate !== null) {
        const limit = parseDateUTC(transaction.limitDate);
        if (date > limit) {
            return false;
        }
    }
    const override = findOverride(transaction, date);
    if (!options.ignoreValidation && isNotDone(transaction, date, options)) {
        return false;
    }
    if (override !== undefined) {
        return override.disabled !== true;
    }
    if (transaction.frequency === 'one-time') {
        return sameUTCDate(date, start);
    }
    if (transaction.frequency === 'monthly') {
        const expectedDay = Math.min(start.getUTCDate(), daysInUTCMonth(date.getUTCFullYear(), date.getUTCMonth() + 1));
        return date.getUTCDate() === expectedDay;
    }
    const elapsedDays = differenceInUTCDays(date, start);
    return elapsedDays % (transaction.frequency === 'weekly' ? 7 : 14) === 0;
}
function isNotDone(transaction, date, options) {
    if (transaction.id === undefined || options.validations === undefined) {
        return false;
    }
    return options.validations.some((validation) => validation.transactionId === transaction.id &&
        validation.status === 'not-done' &&
        sameUTCDate(validation.occurrenceDate, date));
}
//# sourceMappingURL=recurrence.js.map